var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdmContentPreviewClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.2,
    y: 5,
    width: 14,
    height: 2.4,
    rx: 1.2,
    transform: "rotate(90 13.2 5)",
    fill: "#4C6AFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 13.2,
    width: 14,
    height: 2.4,
    rx: 1.2,
    transform: "rotate(-180 19 13.2)",
    fill: "#4C6AFF"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTMuMTk5NyIgeT0iNSIgd2lkdGg9IjE0IiBoZWlnaHQ9IjIuNCIgcng9IjEuMiIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMTMuMTk5NyA1KSIgZmlsbD0iIzRDNkFGRiIvPgo8cmVjdCB4PSIxOC45OTk1IiB5PSIxMy4yIiB3aWR0aD0iMTQiIGhlaWdodD0iMi40IiByeD0iMS4yIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDE4Ljk5OTUgMTMuMikiIGZpbGw9IiM0QzZBRkYiLz4KPC9zdmc+Cg==";
export { SvgEdmContentPreviewClear as ReactComponent };